export default __webpack_public_path__ + "static/media/Vazir.c9f007a4.woff2";